module.exports = __webpack_public_path__ + "media/images/netcredit-logo-high-res-white-322dc513.png";